import { memo } from 'react'
import { Link } from 'react-router-dom'

const Privacy: React.FC = memo(() => {
  return (
    <p className="mt-11 text-center text-dark-neutral-200 text-xs">
      <Link
        data-testid="privacy-policy-link"
        to="https://napsterai.com/privacy"
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      &nbsp;&&nbsp;
      <Link
        data-testid="terms-link"
        to="https://napsterai.com/terms"
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </Link>
      .
    </p>
  )
})

export { Privacy }
